<img class="cvx-img" src="/assets/images/CvxLogo.svg" alt="ChevronLogo"/>
<ul class="tabs">
  <li class="tab">
    <a class="tab-link" [routerLink]="['/dashboard']" routerLinkActive="active">dashboard</a>
    <a class="tab-link" [routerLink]="['/projectsearch']" routerLinkActive="active">projects</a>
  </li>
</ul>
<app-user-button class="usr-btn"></app-user-button>
